var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1021_2737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1142 14.172C17.4032 14.172 16.303 13.3635 15.1442 13.392C13.6142 13.4122 12.2117 14.2792 11.4235 15.6525C9.83571 18.4087 11.014 22.4797 12.5627 24.72C13.3225 25.8105 14.2187 27.0375 15.4067 26.9992C16.5467 26.9505 16.9742 26.259 18.358 26.259C19.7312 26.259 20.1205 26.9992 21.328 26.97C22.5557 26.9505 23.335 25.86 24.085 24.759C24.952 23.493 25.312 22.2652 25.3315 22.1977C25.3022 22.188 22.945 21.282 22.9165 18.555C22.897 16.275 24.7765 15.1845 24.8642 15.1357C23.7925 13.5682 22.147 13.3927 21.5717 13.3537C20.0717 13.2367 18.8155 14.1712 18.1142 14.1712V14.172ZM20.6477 11.8725C21.28 11.1135 21.6977 10.0522 21.5815 9C20.6762 9.039 19.585 9.60375 18.9325 10.3635C18.3475 11.0355 17.842 12.117 17.9777 13.149C18.9812 13.227 20.014 12.633 20.647 11.8732",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1021_2737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.ced89f1b188ec630453cb1f038f9618a.svg";
export { ForwardRef as ReactComponent };